module.exports = __webpack_public_path__ + "img/reading1.73db7ee0.png";